export const translations = {
  en: {
    buttons: {
      getHelp: 'Get Legal Help Now',
      callNow: 'Call Now',
    },
    system: {
      loadingSecureAccess: 'Loading secure access...',
      errorTitle: 'Something went wrong',
      errorBody: 'The app encountered an error. Please refresh the page to try again.',
      refreshPage: 'Refresh Page',
    },
    name: 'Full Name',
    name_placeholder: 'Enter your full name',
    header: {
      languageOptions: {
        en: 'English',
        es: 'Español',
        ht: 'Kreyòl',
        pt: 'Português',
        zh: '中文',
      },
      callNow: 'Call Now',
    },
    floatingContact: {
      title: 'Get Legal Help Now',
      button: 'Get Legal Help Now',
    },
    homepage: {
      heroTitle: 'Know Your Rights. Stay Protected.',
      heroSubtitle:
        'If you or a loved one may encounter immigration enforcement, this tool gives you immediate guidance and direct access to an attorney.',
      primaryButton: 'Get Protected Now-FREE access',
      emergencyButton: 'Emergency - Call Attorney',
      howItWorksTitle: 'How It Works',
      cards: {
        understandRights: {
          title: 'Understand Your Rights',
          body: 'Access legal protections and guidance built for high-pressure situations.',
        },
        immediateGuidance: {
          title: 'Get Immediate Guidance',
          body: 'Move quickly from onboarding into the tools that help you respond safely.',
        },
        contactAttorney: {
          title: 'Contact an Attorney',
          body: 'Secure your access first, then use the app to connect with legal support.',
        },
      },
      trustTitle: 'Your Protection, Our Priority',
      trustText:
        'This tool is provided by Cohen, Tucker & Ades, P.C., an immigration law firm experienced in urgent and complex cases. This tool is for informational purposes only and does not create an attorney-client relationship.',
      learnMoreTitle: 'Learn More About Your Rights',
      learnMoreBody:
        'Explore legal resources, updates, and practical information from the firm.',
      learnMoreButton: 'Visit Our Legal Resources',
    },
    home: {
      heroTitle: 'Know Your Rights. Stay Protected.',
      heroSub:
        'If you or a loved one may encounter immigration enforcement, this tool gives you immediate guidance and direct access to an attorney.',
      howTitle: 'How It Works',
      card1Title: 'Understand Your Rights',
      card1Desc: 'Access legal protections and guidance built for high-pressure situations.',
      card2Title: 'Get Immediate Guidance',
      card2Desc: 'Move quickly from onboarding into the tools that help you respond safely.',
      card3Title: 'Contact an Attorney',
      card3Desc: 'Secure your access first, then use the app to connect with legal support.',
      infoTitle: 'Learn More About Your Rights',
      infoDesc: 'Explore legal resources, updates, and practical information from the firm.',
      learnMore: 'Visit Our Legal Resources',
    },
    register: {
      back: '← Back',
      title: 'Create Your Account',
      sub:
        'Register to securely build your profile and access your legal protection tools.',
      intro:
        'Register to securely build your profile and access your legal protection tools.',
      email: 'Email',
      emailLabel: 'Email',
      emailPlaceholder: 'your.email@example.com',
      password: 'Password',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Create a password',
      confirm: 'Confirm Password',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your password',
      registerBtn: 'Register',
      submitIdle: 'Register',
      submitLoading: 'Creating Account...',
      google: 'Continue with Google',
      continueWithGoogle: 'Continue with Google',
      existing: 'Already Have an Account?',
      alreadyHaveAccount: 'Already Have an Account?',
      errors: {
        passwordMismatch: 'Passwords do not match.',
        unableToCreateAccount: 'Unable to create account.',
        unableToContinueWithGoogle: 'Unable to continue with Google.',
      },
    },
    login: {
      back: '← Back',
      title: 'Client Login',
      intro: 'Sign in to continue your secure profile setup and access legal guidance.',
      email: 'Email',
      emailPlaceholder: 'your.email@example.com',
      password: 'Password',
      passwordPlaceholder: 'Enter your password',
      submitIdle: 'Login',
      submitLoading: 'Signing In...',
      createAccount: 'Create Account',
      errors: {
        unableToSignIn: 'Unable to sign in.',
      },
    },
    intake: {
      back: '← Back',
      title: 'Secure Profile Setup',
      intro:
        'Build your secure profile so Cohen, Tucker & Ades, P.C. can provide legal tools and follow-up support more effectively.',
      nameRequired: 'Full name is required',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      emailRequired: 'Email is required',
      phone: 'Phone Number',
      phoneRequired: 'Phone number is required',
      address: 'Address',
      preferredLanguage: 'Preferred Language',
      preferredLanguagePlaceholder: 'Select your preferred language',
      preferredLanguageRequired: 'Preferred language is required',
      english: 'English',
      spanish: 'Spanish',
      other: 'Other',
      describe: 'Briefly describe your situation',
      descriptionRequired: 'A brief description is required',
      consent:
        'I agree that my contact information may be used to communicate with the law firm. I understand confidential legal details are not stored or shared beyond my attorney.',
      contactConsentText:
        'I agree to the Terms of Use and Privacy Policy and consent to being contacted by Cohen, Tucker & Ades, P.C. by phone, email, and SMS (message/data rates may apply). Consent is not required to hire the firm.',
      contactConsentBeforeTerms: 'I agree to the ',
      contactConsentBetweenLinks: ' and ',
      contactConsentAfterPrivacy:
        ' and consent to being contacted by Cohen, Tucker & Ades, P.C. by phone, email, and SMS (message/data rates may apply). Consent is not required to hire the firm.',
      contactConsentNote:
        'We collect and use your information for communication and case evaluation. See the Privacy Policy for details.',
      submit: 'Access your Legal Rights',
      errors: {
        mustAgree: 'You must agree before continuing.',
        submitError: 'We could not complete setup right now. Please try again.',
      },
      mustAcceptTerms: 'You must agree to the Terms and Privacy Policy.',
    },
    dashboard: {
      back: '← Back',
      title: 'Choose Your Scenario',
      subtitle:
        'Select the situation that best matches your current concern to view focused legal guidance.',
      intro:
        'Select the situation that best matches your current concern to view focused legal guidance.',
      publicTitle: '🚓 If ICE Stops You in Public',
      publicDesc: 'Step-by-step guidance for street stops, questioning, and public encounters.',
      workTitle: '🏢 If ICE Comes to Your Workplace',
      workDesc: 'Know your rights at work and what to do if agents approach your location.',
      homeTitle: '🏠 If ICE Comes to Your Home',
      homeDesc: 'Learn how to respond at the door and protect your household legally.',
      scenarios: {
        public: {
          title: '🚓 If ICE Stops You in Public',
          description:
            'Step-by-step guidance for street stops, questioning, and public encounters.',
        },
        workplace: {
          title: '🏢 If ICE Comes to Your Workplace',
          description:
            'Know your rights at work and what to do if agents approach your location.',
        },
        home: {
          title: '🏠 If ICE Comes to Your Home',
          description: 'Learn how to respond at the door and protect your household legally.',
        },
      },
      contactTitle: '📞 Contact Attorney',
      contactDesc: 'Reach our legal team immediately for guidance and assistance.',
      contactAttorneyTitle: '📞 Contact Attorney',
      contactAttorneyBody: 'Reach our legal team immediately for guidance and assistance.',
      getHelp: 'Call Attorney Now',
      callAttorneyNow: 'Call Attorney Now',
      emailAttorney: 'Email Attorney',
      learnMore: 'Learn More →',
      logout: 'Logout',
    },
    contactFlow: {
      title: 'Connecting You With Legal Help',
      statusPreparing: 'Preparing your contact request...',
      statusMissing:
        'We could not load your intake details. You can still use the firm contact information below.',
      statusGuest:
        'Your contact request has been started. Your email draft should open automatically. You will be prompted to create an account next.',
      statusStarted:
        'Your contact request has been started. Your email draft should open automatically. If it does not, use the firm contact information below.',
      labels: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        language: 'Language',
        scenario: 'Scenario',
        details: 'Details',
      },
      defaults: {
        guest: 'Guest',
        notProvided: 'Not provided',
      },
      actions: {
        returnToDashboard: 'Return to dashboard',
        createAccount: 'Create an account',
      },
      emailDraft: {
        subject: 'Legal Assistance Request from Know Your Rights App',
        greeting: 'Hello,',
        intro: 'I need assistance with my immigration matter.',
        detailsLabel: 'Details:',
        pleaseContact: 'Please contact me as soon as possible.',
        thanks: 'Thank you.',
      },
    },
    accordion: {
      shared: {
        whatToDoImmediately: 'What to Do Immediately',
        yourLegalRights: 'Your Legal Rights',
        whatToSay: 'What to Say (Script)',
        whatNotToDo: 'What NOT to Do',
      },
      public: {
        back: '← Back',
        title: '🚓 If ICE Stops You in Public',
        intro:
          'Follow these steps to protect yourself and preserve your legal rights during a public stop.',
        sections: {
          what: [
            'Stay calm, do not run.',
            'Ask: "Am I free to leave?"',
            'If yes, walk away calmly.',
            'If no, remain silent.',
          ],
          rights: [
            'You have the right to remain silent.',
            'You do not have to answer where you were born.',
            'You do not have to show documents revealing immigration status.',
            'You may refuse searches, except a limited pat-down for safety.',
          ],
          say: ['"I am exercising my right to remain silent. I want to speak to a lawyer."'],
          not: [
            'Do not lie.',
            'Do not provide fake documents.',
            'Do not resist physically.',
            'Do not answer questions about immigration status.',
          ],
        },
      },
      home: {
        back: '← Back',
        title: '🏠 If ICE Comes to Your Home',
        what: 'What to Do Immediately',
        rights: 'Your Legal Rights',
        say: 'What to Say (Script)',
        not: 'What NOT to Do',
        intro:
          'Follow these steps to protect your household and handle a home encounter lawfully.',
        sections: {
          what: [
            'Do not open the door.',
            'Ask them to slide the warrant under the door.',
            'Check whether it is signed by a judge, not an ICE officer.',
            'Check whether it has the correct name and address.',
          ],
          rights: [
            'Officers cannot enter without a judicial warrant or your consent.',
            'You have the right to remain silent.',
            'You have the right to a lawyer.',
          ],
          say: ['"I do not consent to entry. Please leave the property."'],
          not: [
            'Do not open the door voluntarily.',
            'Do not sign anything.',
            'Do not let officers in without a valid judicial warrant.',
          ],
        },
      },
      work: {
        back: '← Back',
        title: '🏢 If ICE Comes to Your Workplace',
        what: 'What to Do Immediately',
        rights: 'Your Legal Rights',
        say: 'What to Say (Script)',
        not: 'What NOT to Do',
        intro:
          'Use this guidance to respond calmly, protect your rights, and avoid harmful mistakes at work.',
        sections: {
          what: [
            'Do not run.',
            'Stay calm.',
            'Ask if you are free to leave.',
            'If yes, leave calmly.',
          ],
          rights: [
            'ICE needs a warrant for non-public areas.',
            'You have the right to remain silent.',
            'You do not have to answer immigration status questions.',
          ],
          say: ['"I choose to remain silent and want a lawyer."'],
          not: [
            'Do not provide false information.',
            'Do not panic or run.',
            'Do not sign documents.',
          ],
        },
      },
    },
    legal: {
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      deleteAccount: 'Delete Account',
      consent:
        'I agree that my contact information may be used to communicate with the law firm. I understand confidential legal details are not stored or shared beyond my attorney.',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      disclaimer:
        'This tool provides general information only and does not constitute legal advice or create an attorney-client relationship.',
      attorneyAdvertising:
        'Attorney Advertising. Prior results do not guarantee similar outcomes.',
      noTracking:
        'No third-party tracking. Your data is used only for communication and legal service purposes.',
      firmName: 'Cohen, Tucker & Ades, P.C.',
      phone: '📞 +1 (212) 840-0050',
      email: '📧 info@cohentuckerlaw.com',
      address: '📍 42 Broadway, Suite 310, New York, NY',
    },
    privacy: {
      title: 'Privacy Policy',
      intro:
        'This Privacy Policy explains the basic information collected through this app and how it is used to support communication and service delivery.',
      items: [
        'We collect basic contact information, including name, email, and phone.',
        'Data is used only for communication and service delivery.',
        'No sale or sharing of personal data takes place through this app.',
        'Legal information remains confidential with the attorney.',
        'Users may request deletion of their data.',
      ],
      returnHome: 'Return home',
    },
    terms: {
      title: 'Terms of Use',
      intro:
        'These Terms of Use describe the limits of this app and the user responsibilities that apply when submitting information.',
      items: [
        'This app provides general legal information, not legal advice.',
        'Use of this app does not create an attorney-client relationship.',
        'Communication with the firm is required for legal representation.',
        'Users are responsible for the accuracy of submitted information.',
      ],
      returnHome: 'Return home',
    },
  },
  es: {
    buttons: {
      getHelp: 'Obtenga ayuda legal ahora',
      callNow: 'Llame ahora',
    },
    system: {
      loadingSecureAccess: 'Cargando acceso seguro...',
      errorTitle: 'Algo salio mal',
      errorBody: 'La aplicacion encontro un error. Actualice la pagina para volver a intentarlo.',
      refreshPage: 'Actualizar pagina',
    },
    name: 'Nombre completo',
    name_placeholder: 'Ingrese su nombre completo',
    header: {
      languageOptions: {
        en: 'Inglés',
        es: 'Español',
        ht: 'Criollo haitiano',
        pt: 'Portugués',
        zh: 'Chino',
      },
      callNow: 'Llame ahora',
    },
    floatingContact: {
      title: 'Obtenga ayuda legal ahora',
      button: 'Obtenga ayuda legal ahora',
    },
    homepage: {
      heroTitle: 'Conozca sus derechos. Manténgase protegido.',
      heroSubtitle:
        'Si usted o un ser querido podría encontrarse con agentes de inmigración, esta herramienta le brinda orientación inmediata y acceso directo a un abogado.',
      primaryButton: 'Protéjase ahora - acceso GRATIS',
      emergencyButton: 'Emergencia - Llame a un abogado',
      howItWorksTitle: 'Cómo funciona',
      cards: {
        understandRights: {
          title: 'Conozca sus derechos',
          body: 'Acceda a protecciones legales y orientación diseñadas para situaciones de alta presión.',
        },
        immediateGuidance: {
          title: 'Obtenga orientación inmediata',
          body: 'Avance rápidamente desde el registro hacia las herramientas que le ayudan a responder con seguridad.',
        },
        contactAttorney: {
          title: 'Contacte a un abogado',
          body: 'Asegure primero su acceso y luego use la aplicación para conectarse con apoyo legal.',
        },
      },
      trustTitle: 'Su protección es nuestra prioridad',
      trustText:
        'Esta herramienta es proporcionada por Cohen, Tucker & Ades, P.C., una firma de abogados de inmigración con experiencia en casos urgentes y complejos. Esta herramienta es solo para fines informativos y no crea una relación abogado-cliente.',
      learnMoreTitle: 'Aprenda más sobre sus derechos',
      learnMoreBody:
        'Explore recursos legales, actualizaciones e información práctica de la firma.',
      learnMoreButton: 'Visite nuestros recursos legales',
    },
    home: {
      heroTitle: 'Conozca sus derechos. Manténgase protegido.',
      heroSub:
        'Si usted o un ser querido podría encontrarse con agentes de inmigración, esta herramienta le brinda orientación inmediata y acceso directo a un abogado.',
      howTitle: 'Cómo funciona',
      card1Title: 'Conozca sus derechos',
      card1Desc: 'Acceda a protecciones legales y orientación diseñadas para situaciones de alta presión.',
      card2Title: 'Obtenga orientación inmediata',
      card2Desc: 'Avance rápidamente desde el registro hacia las herramientas que le ayudan a responder con seguridad.',
      card3Title: 'Contacte a un abogado',
      card3Desc: 'Asegure primero su acceso y luego use la aplicación para conectarse con apoyo legal.',
      infoTitle: 'Aprenda más sobre sus derechos',
      infoDesc: 'Explore recursos legales, actualizaciones e información práctica de la firma.',
      learnMore: 'Visite nuestros recursos legales',
    },
    register: {
      back: '← Volver',
      title: 'Cree su cuenta',
      sub:
        'Regístrese para crear de forma segura su perfil y acceder a sus herramientas de protección legal.',
      intro:
        'Regístrese para crear de forma segura su perfil y acceder a sus herramientas de protección legal.',
      email: 'Correo electrónico',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'su.correo@ejemplo.com',
      password: 'Contraseña',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Cree una contraseña',
      confirm: 'Confirmar contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      confirmPasswordPlaceholder: 'Confirme su contraseña',
      registerBtn: 'Registrarse',
      submitIdle: 'Registrarse',
      submitLoading: 'Creando cuenta...',
      google: 'Continuar con Google',
      continueWithGoogle: 'Continuar con Google',
      existing: '¿Ya tiene una cuenta?',
      alreadyHaveAccount: '¿Ya tiene una cuenta?',
      errors: {
        passwordMismatch: 'Las contraseñas no coinciden.',
        unableToCreateAccount: 'No se pudo crear la cuenta.',
        unableToContinueWithGoogle: 'No se pudo continuar con Google.',
      },
    },
    login: {
      back: '← Volver',
      title: 'Inicio de sesion del cliente',
      intro:
        'Inicie sesion para continuar con la configuracion segura de su perfil y acceder a orientacion legal.',
      email: 'Correo electronico',
      emailPlaceholder: 'su.correo@ejemplo.com',
      password: 'Contraseña',
      passwordPlaceholder: 'Ingrese su contraseña',
      submitIdle: 'Iniciar sesion',
      submitLoading: 'Iniciando sesion...',
      createAccount: 'Crear cuenta',
      errors: {
        unableToSignIn: 'No se pudo iniciar sesion.',
      },
    },
    intake: {
      back: '← Volver',
      title: 'Configuración segura del perfil',
      intro:
        'Cree su perfil seguro para que Cohen, Tucker & Ades, P.C. pueda brindarle herramientas legales y apoyo de seguimiento de manera más efectiva.',
      nameRequired: 'Se requiere el nombre completo',
      email: 'Correo electrónico',
      emailPlaceholder: 'Ingrese su correo electrónico',
      emailRequired: 'Se requiere el correo electrónico',
      phone: 'Número de teléfono',
      phoneRequired: 'Se requiere un número de teléfono',
      address: 'Dirección',
      preferredLanguage: 'Idioma preferido',
      preferredLanguagePlaceholder: 'Seleccione su idioma preferido',
      preferredLanguageRequired: 'Se requiere el idioma preferido',
      english: 'Inglés',
      spanish: 'Español',
      other: 'Otro',
      describe: 'Describa brevemente su situación',
      descriptionRequired: 'Se requiere una breve descripción',
      consent:
        'Acepto que mi información de contacto pueda usarse para comunicarse conmigo desde la firma de abogados. Entiendo que los detalles legales confidenciales no se almacenan ni se comparten fuera de mi abogado.',
      contactConsentText:
        'Acepto los Terminos de uso y la Politica de privacidad y doy mi consentimiento para que Cohen, Tucker & Ades, P.C. se comunique conmigo por telefono, correo electronico y SMS (pueden aplicarse cargos por mensajes y datos). No es obligatorio dar su consentimiento para contratar a la firma.',
      contactConsentBeforeTerms: 'Acepto los ',
      contactConsentBetweenLinks: ' y la ',
      contactConsentAfterPrivacy:
        ' y doy mi consentimiento para que Cohen, Tucker & Ades, P.C. se comunique conmigo por telefono, correo electronico y SMS (pueden aplicarse cargos por mensajes y datos). No es obligatorio dar su consentimiento para contratar a la firma.',
      contactConsentNote:
        'Recopilamos y usamos su informacion para comunicacion y evaluacion del caso. Consulte la Politica de privacidad para obtener mas detalles.',
      submit: 'Acceda a sus derechos legales',
      errors: {
        mustAgree: 'Debe aceptar antes de continuar.',
        submitError: 'No pudimos completar la configuración en este momento. Inténtelo de nuevo.',
      },
      mustAcceptTerms: 'Debe aceptar los Terminos y la Politica de privacidad.',
    },
    dashboard: {
      back: '← Volver',
      title: 'Elija su situación',
      subtitle:
        'Seleccione la situación que mejor coincida con su preocupación actual para ver orientación legal específica.',
      intro:
        'Seleccione la situación que mejor coincida con su preocupación actual para ver orientación legal específica.',
      publicTitle: '🚓 Si ICE lo detiene en público',
      publicDesc: 'Orientación paso a paso para detenciones en la calle, preguntas y encuentros en público.',
      workTitle: '🏢 Si ICE llega a su lugar de trabajo',
      workDesc: 'Conozca sus derechos en el trabajo y qué hacer si los agentes se acercan a su lugar.',
      homeTitle: '🏠 Si ICE llega a su casa',
      homeDesc: 'Aprenda cómo responder en la puerta y proteger legalmente a su hogar.',
      scenarios: {
        public: {
          title: '🚓 Si ICE lo detiene en público',
          description:
            'Orientación paso a paso para detenciones en la calle, preguntas y encuentros en público.',
        },
        workplace: {
          title: '🏢 Si ICE llega a su lugar de trabajo',
          description:
            'Conozca sus derechos en el trabajo y qué hacer si los agentes se acercan a su lugar.',
        },
        home: {
          title: '🏠 Si ICE llega a su casa',
          description: 'Aprenda cómo responder en la puerta y proteger legalmente a su hogar.',
        },
      },
      contactTitle: '📞 Contactar a un abogado',
      contactDesc: 'Comuníquese de inmediato con nuestro equipo legal para recibir orientación y ayuda.',
      contactAttorneyTitle: '📞 Contactar a un abogado',
      contactAttorneyBody: 'Comuníquese de inmediato con nuestro equipo legal para recibir orientación y ayuda.',
      getHelp: 'Llamar al abogado ahora',
      callAttorneyNow: 'Llamar al abogado ahora',
      emailAttorney: 'Enviar correo al abogado',
      learnMore: 'Más información →',
      logout: 'Cerrar sesion',
    },
    contactFlow: {
      title: 'Conectandolo con ayuda legal',
      statusPreparing: 'Preparando su solicitud de contacto...',
      statusMissing:
        'No pudimos cargar los datos de su intake. Aun puede usar la informacion de contacto de la firma que aparece abajo.',
      statusGuest:
        'Se inicio su solicitud de contacto. El borrador del correo deberia abrirse automaticamente. Despues se le pedira crear una cuenta.',
      statusStarted:
        'Se inicio su solicitud de contacto. El borrador del correo deberia abrirse automaticamente. Si no se abre, use la informacion de contacto de la firma que aparece abajo.',
      labels: {
        name: 'Nombre',
        email: 'Correo electronico',
        phone: 'Telefono',
        address: 'Direccion',
        language: 'Idioma',
        scenario: 'Situacion',
        details: 'Detalles',
      },
      defaults: {
        guest: 'Invitado',
        notProvided: 'No proporcionado',
      },
      actions: {
        returnToDashboard: 'Volver al panel',
        createAccount: 'Crear una cuenta',
      },
      emailDraft: {
        subject: 'Solicitud de ayuda legal de Know Your Rights App',
        greeting: 'Hola,',
        intro: 'Necesito ayuda con mi asunto de inmigracion.',
        detailsLabel: 'Detalles:',
        pleaseContact: 'Por favor, comuniquese conmigo lo antes posible.',
        thanks: 'Gracias.',
      },
    },
    accordion: {
      shared: {
        whatToDoImmediately: 'Qué hacer de inmediato',
        yourLegalRights: 'Sus derechos legales',
        whatToSay: 'Qué decir (guion)',
        whatNotToDo: 'Qué NO hacer',
      },
      public: {
        back: '← Volver',
        title: '🚓 Si ICE lo detiene en público',
        intro:
          'Siga estos pasos para protegerse y preservar sus derechos legales durante una detención en público.',
        sections: {
          what: [
            'Mantenga la calma, no corra.',
            'Pregunte: "¿Soy libre de irme?"',
            'Si la respuesta es sí, aléjese con calma.',
            'Si la respuesta es no, permanezca en silencio.',
          ],
          rights: [
            'Tiene derecho a guardar silencio.',
            'No tiene que responder dónde nació.',
            'No tiene que mostrar documentos que revelen su estatus migratorio.',
            'Puede negarse a registros, excepto a una revisión limitada por seguridad.',
          ],
          say: ['"Estoy ejerciendo mi derecho a guardar silencio. Quiero hablar con un abogado."'],
          not: [
            'No mienta.',
            'No entregue documentos falsos.',
            'No se resista físicamente.',
            'No responda preguntas sobre su estatus migratorio.',
          ],
        },
      },
      home: {
        back: '← Volver',
        title: '🏠 Si ICE llega a su casa',
        what: 'Qué hacer de inmediato',
        rights: 'Sus derechos legales',
        say: 'Qué decir (guion)',
        not: 'Qué NO hacer',
        intro:
          'Siga estos pasos para proteger a su hogar y manejar legalmente un encuentro en casa.',
        sections: {
          what: [
            'No abra la puerta.',
            'Pídales que deslicen la orden por debajo de la puerta.',
            'Verifique si está firmada por un juez y no por un oficial de ICE.',
            'Verifique si tiene el nombre y la dirección correctos.',
          ],
          rights: [
            'Los oficiales no pueden entrar sin una orden judicial o su consentimiento.',
            'Tiene derecho a guardar silencio.',
            'Tiene derecho a un abogado.',
          ],
          say: ['"No doy mi consentimiento para que entren. Por favor, salgan de la propiedad."'],
          not: [
            'No abra la puerta voluntariamente.',
            'No firme nada.',
            'No deje entrar a los oficiales sin una orden judicial válida.',
          ],
        },
      },
      work: {
        back: '← Volver',
        title: '🏢 Si ICE llega a su lugar de trabajo',
        what: 'Qué hacer de inmediato',
        rights: 'Sus derechos legales',
        say: 'Qué decir (guion)',
        not: 'Qué NO hacer',
        intro:
          'Use esta orientación para responder con calma, proteger sus derechos y evitar errores perjudiciales en el trabajo.',
        sections: {
          what: [
            'No corra.',
            'Mantenga la calma.',
            'Pregunte si es libre de irse.',
            'Si la respuesta es sí, váyase con calma.',
          ],
          rights: [
            'ICE necesita una orden para las áreas no públicas.',
            'Tiene derecho a guardar silencio.',
            'No tiene que responder preguntas sobre su estatus migratorio.',
          ],
          say: ['"Elijo guardar silencio y quiero un abogado."'],
          not: [
            'No proporcione información falsa.',
            'No entre en pánico ni corra.',
            'No firme documentos.',
          ],
        },
      },
    },
    legal: {
      privacy: 'Política de privacidad',
      terms: 'Términos de uso',
      deleteAccount: 'Eliminar cuenta',
      consent:
        'Acepto que mi información de contacto pueda usarse para comunicarse conmigo desde la firma de abogados. Entiendo que los detalles legales confidenciales no se almacenan ni se comparten fuera de mi abogado.',
      privacyPolicy: 'Política de privacidad',
      termsOfUse: 'Términos de uso',
      disclaimer:
        'Esta herramienta solo proporciona información general y no constituye asesoría legal ni crea una relación abogado-cliente.',
      attorneyAdvertising:
        'Publicidad de abogados. Los resultados previos no garantizan resultados similares.',
      noTracking:
        'Sin rastreo de terceros. Sus datos se usan solo para comunicacion y servicios legales.',
      firmName: 'Cohen, Tucker & Ades, P.C.',
      phone: '📞 +1 (212) 840-0050',
      email: '📧 info@cohentuckerlaw.com',
      address: '📍 42 Broadway, Suite 310, New York, NY',
    },
    privacy: {
      title: 'Política de privacidad',
      intro:
        'Esta Política de Privacidad explica la información básica recopilada a través de esta aplicación y cómo se utiliza para apoyar la comunicación y la prestación de servicios.',
      items: [
        'Recopilamos información básica de contacto, incluyendo nombre, correo electrónico y teléfono.',
        'Los datos se usan únicamente para la comunicación y la prestación de servicios.',
        'No se realiza venta ni intercambio de datos personales a través de esta aplicación.',
        'La información legal permanece confidencial con el abogado.',
        'Los usuarios pueden solicitar la eliminación de sus datos.',
      ],
      returnHome: 'Volver al inicio',
    },
    terms: {
      title: 'Términos de uso',
      intro:
        'Estos Términos de Uso describen los límites de esta aplicación y las responsabilidades del usuario al enviar información.',
      items: [
        'Esta aplicación ofrece información legal general, no asesoría legal.',
        'El uso de esta aplicación no crea una relación abogado-cliente.',
        'Se requiere comunicación con la firma para obtener representación legal.',
        'Los usuarios son responsables de la exactitud de la información enviada.',
      ],
      returnHome: 'Volver al inicio',
    },
  },
  pt: {
    buttons: {
      getHelp: 'Obtenha ajuda jurídica agora',
      callNow: 'Ligue agora',
    },
    system: {
      loadingSecureAccess: 'Carregando acesso seguro...',
      errorTitle: 'Algo deu errado',
      errorBody: 'O aplicativo encontrou um erro. Atualize a pagina para tentar novamente.',
      refreshPage: 'Atualizar pagina',
    },
    name: 'Nome completo',
    name_placeholder: 'Digite seu nome completo',
    header: {
      languageOptions: {
        en: 'Inglês',
        es: 'Espanhol',
        ht: 'Crioulo haitiano',
        pt: 'Português',
        zh: 'Chinês',
      },
      callNow: 'Ligue agora',
    },
    floatingContact: {
      title: 'Obtenha ajuda jurídica agora',
      button: 'Obtenha ajuda jurídica agora',
    },
    homepage: {
      heroTitle: 'Conheça seus direitos. Mantenha-se protegido.',
      heroSubtitle:
        'Se você ou um ente querido puder encontrar a fiscalização de imigração, esta ferramenta oferece orientação imediata e acesso direto a um advogado.',
      primaryButton: 'Proteja-se agora - acesso GRATIS',
      emergencyButton: 'Emergência - Ligue para um advogado',
      howItWorksTitle: 'Como funciona',
      cards: {
        understandRights: {
          title: 'Conheça seus direitos',
          body: 'Acesse proteções legais e orientações criadas para situações de alta pressão.',
        },
        immediateGuidance: {
          title: 'Receba orientação imediata',
          body: 'Avance rapidamente do cadastro para as ferramentas que ajudam você a responder com segurança.',
        },
        contactAttorney: {
          title: 'Entre em contato com um advogado',
          body: 'Garanta primeiro o seu acesso e depois use o aplicativo para falar com o suporte jurídico.',
        },
      },
      trustTitle: 'Sua proteção é nossa prioridade',
      trustText:
        'Esta ferramenta é fornecida por Cohen, Tucker & Ades, P.C., um escritório de advocacia de imigração com experiência em casos urgentes e complexos. Esta ferramenta é apenas para fins informativos e não cria uma relação advogado-cliente.',
      learnMoreTitle: 'Saiba mais sobre seus direitos',
      learnMoreBody:
        'Explore recursos jurídicos, atualizações e informações práticas do escritório.',
      learnMoreButton: 'Visite nossos recursos jurídicos',
    },
    home: {
      heroTitle: 'Conheça seus direitos. Mantenha-se protegido.',
      heroSub:
        'Se você ou um ente querido puder encontrar a fiscalização de imigração, esta ferramenta oferece orientação imediata e acesso direto a um advogado.',
      howTitle: 'Como funciona',
      card1Title: 'Conheça seus direitos',
      card1Desc: 'Acesse proteções legais e orientações criadas para situações de alta pressão.',
      card2Title: 'Receba orientação imediata',
      card2Desc: 'Avance rapidamente do cadastro para as ferramentas que ajudam você a responder com segurança.',
      card3Title: 'Entre em contato com um advogado',
      card3Desc: 'Garanta primeiro o seu acesso e depois use o aplicativo para falar com o suporte jurídico.',
      infoTitle: 'Saiba mais sobre seus direitos',
      infoDesc: 'Explore recursos jurídicos, atualizações e informações práticas do escritório.',
      learnMore: 'Visite nossos recursos jurídicos',
    },
    register: {
      back: '← Voltar',
      title: 'Crie sua conta',
      sub:
        'Cadastre-se para criar seu perfil com segurança e acessar suas ferramentas de proteção jurídica.',
      intro:
        'Cadastre-se para criar seu perfil com segurança e acessar suas ferramentas de proteção jurídica.',
      email: 'E-mail',
      emailLabel: 'E-mail',
      emailPlaceholder: 'seu.email@exemplo.com',
      password: 'Senha',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Crie uma senha',
      confirm: 'Confirmar senha',
      confirmPasswordLabel: 'Confirmar senha',
      confirmPasswordPlaceholder: 'Confirme sua senha',
      registerBtn: 'Cadastrar',
      submitIdle: 'Cadastrar',
      submitLoading: 'Criando conta...',
      google: 'Continuar com o Google',
      continueWithGoogle: 'Continuar com o Google',
      existing: 'Já tem uma conta?',
      alreadyHaveAccount: 'Já tem uma conta?',
      errors: {
        passwordMismatch: 'As senhas não coincidem.',
        unableToCreateAccount: 'Não foi possível criar a conta.',
        unableToContinueWithGoogle: 'Não foi possível continuar com o Google.',
      },
    },
    login: {
      back: '← Voltar',
      title: 'Login do cliente',
      intro:
        'Entre para continuar a configuracao segura do seu perfil e acessar orientacao juridica.',
      email: 'E-mail',
      emailPlaceholder: 'seu.email@exemplo.com',
      password: 'Senha',
      passwordPlaceholder: 'Digite sua senha',
      submitIdle: 'Entrar',
      submitLoading: 'Entrando...',
      createAccount: 'Criar conta',
      errors: {
        unableToSignIn: 'Nao foi possivel entrar.',
      },
    },
    intake: {
      back: '← Voltar',
      title: 'Configuração segura do perfil',
      intro:
        'Crie seu perfil seguro para que Cohen, Tucker & Ades, P.C. possa fornecer ferramentas jurídicas e suporte de acompanhamento com mais eficiência.',
      nameRequired: 'O nome completo é obrigatório',
      email: 'E-mail',
      emailPlaceholder: 'Digite seu e-mail',
      emailRequired: 'O e-mail é obrigatório',
      phone: 'Número de telefone',
      phoneRequired: 'O número de telefone é obrigatório',
      address: 'Endereço',
      preferredLanguage: 'Idioma preferido',
      preferredLanguagePlaceholder: 'Selecione seu idioma preferido',
      preferredLanguageRequired: 'O idioma preferido é obrigatório',
      english: 'Inglês',
      spanish: 'Espanhol',
      other: 'Outro',
      describe: 'Descreva brevemente sua situação',
      descriptionRequired: 'Uma breve descrição é obrigatória',
      consent:
        'Concordo que minhas informações de contato possam ser usadas para comunicação com o escritório de advocacia. Entendo que detalhes jurídicos confidenciais não são armazenados nem compartilhados fora do meu advogado.',
      contactConsentText:
        'Concordo com os Termos de uso e a Politica de privacidade e autorizo que Cohen, Tucker & Ades, P.C. entre em contato comigo por telefone, e-mail e SMS (podem ser aplicadas tarifas de mensagem e dados). O consentimento nao e exigido para contratar o escritorio.',
      contactConsentBeforeTerms: 'Concordo com os ',
      contactConsentBetweenLinks: ' e a ',
      contactConsentAfterPrivacy:
        ' e autorizo que Cohen, Tucker & Ades, P.C. entre em contato comigo por telefone, e-mail e SMS (podem ser aplicadas tarifas de mensagem e dados). O consentimento nao e exigido para contratar o escritorio.',
      contactConsentNote:
        'Coletamos e usamos suas informacoes para comunicacao e avaliacao do caso. Consulte a Politica de privacidade para mais detalhes.',
      submit: 'Acesse seus direitos legais',
      errors: {
        mustAgree: 'Você deve concordar antes de continuar.',
        submitError: 'Não foi possível concluir a configuração agora. Tente novamente.',
      },
      mustAcceptTerms: 'Voce deve concordar com os Termos e a Politica de privacidade.',
    },
    dashboard: {
      back: '← Voltar',
      title: 'Escolha sua situação',
      subtitle:
        'Selecione a situação que mais corresponde à sua preocupação atual para ver orientação jurídica específica.',
      intro:
        'Selecione a situação que mais corresponde à sua preocupação atual para ver orientação jurídica específica.',
      publicTitle: '🚓 Se o ICE parar você em público',
      publicDesc: 'Orientação passo a passo para abordagens na rua, questionamentos e encontros em público.',
      workTitle: '🏢 Se o ICE for ao seu local de trabalho',
      workDesc: 'Conheça seus direitos no trabalho e saiba o que fazer se agentes chegarem ao local.',
      homeTitle: '🏠 Se o ICE for à sua casa',
      homeDesc: 'Saiba como responder à porta e proteger legalmente sua família.',
      scenarios: {
        public: {
          title: '🚓 Se o ICE parar você em público',
          description:
            'Orientação passo a passo para abordagens na rua, questionamentos e encontros em público.',
        },
        workplace: {
          title: '🏢 Se o ICE for ao seu local de trabalho',
          description:
            'Conheça seus direitos no trabalho e saiba o que fazer se agentes chegarem ao local.',
        },
        home: {
          title: '🏠 Se o ICE for à sua casa',
          description: 'Saiba como responder à porta e proteger legalmente sua família.',
        },
      },
      contactTitle: '📞 Contatar advogado',
      contactDesc: 'Entre em contato com nossa equipe jurídica imediatamente para receber orientação e ajuda.',
      contactAttorneyTitle: '📞 Contatar advogado',
      contactAttorneyBody: 'Entre em contato com nossa equipe jurídica imediatamente para receber orientação e ajuda.',
      getHelp: 'Ligar para o advogado agora',
      callAttorneyNow: 'Ligar para o advogado agora',
      emailAttorney: 'Enviar e-mail ao advogado',
      learnMore: 'Saiba mais →',
      logout: 'Sair',
    },
    contactFlow: {
      title: 'Conectando voce a ajuda juridica',
      statusPreparing: 'Preparando sua solicitacao de contato...',
      statusMissing:
        'Nao foi possivel carregar seus dados de intake. Ainda assim, voce pode usar as informacoes de contato do escritorio abaixo.',
      statusGuest:
        'Sua solicitacao de contato foi iniciada. O rascunho do e-mail deve abrir automaticamente. Em seguida, voce sera orientado a criar uma conta.',
      statusStarted:
        'Sua solicitacao de contato foi iniciada. O rascunho do e-mail deve abrir automaticamente. Se isso nao acontecer, use as informacoes de contato do escritorio abaixo.',
      labels: {
        name: 'Nome',
        email: 'E-mail',
        phone: 'Telefone',
        address: 'Endereco',
        language: 'Idioma',
        scenario: 'Situacao',
        details: 'Detalhes',
      },
      defaults: {
        guest: 'Convidado',
        notProvided: 'Nao informado',
      },
      actions: {
        returnToDashboard: 'Voltar ao painel',
        createAccount: 'Criar uma conta',
      },
      emailDraft: {
        subject: 'Solicitacao de ajuda juridica do Know Your Rights App',
        greeting: 'Ola,',
        intro: 'Preciso de ajuda com minha questao de imigracao.',
        detailsLabel: 'Detalhes:',
        pleaseContact: 'Por favor, entre em contato comigo o quanto antes.',
        thanks: 'Obrigado.',
      },
    },
    accordion: {
      shared: {
        whatToDoImmediately: 'O que fazer imediatamente',
        yourLegalRights: 'Seus direitos legais',
        whatToSay: 'O que dizer (roteiro)',
        whatNotToDo: 'O que NÃO fazer',
      },
      public: {
        back: '← Voltar',
        title: '🚓 Se o ICE parar você em público',
        intro:
          'Siga estas etapas para se proteger e preservar seus direitos legais durante uma abordagem em público.',
        sections: {
          what: [
            'Mantenha a calma, não corra.',
            'Pergunte: "Estou livre para ir embora?"',
            'Se a resposta for sim, afaste-se com calma.',
            'Se a resposta for não, permaneça em silêncio.',
          ],
          rights: [
            'Você tem o direito de permanecer em silêncio.',
            'Você não precisa responder onde nasceu.',
            'Você não precisa mostrar documentos que revelem seu status imigratório.',
            'Você pode recusar buscas, exceto uma revista limitada por segurança.',
          ],
          say: ['"Estou exercendo meu direito de permanecer em silêncio. Quero falar com um advogado."'],
          not: [
            'Não minta.',
            'Não forneça documentos falsos.',
            'Não resista fisicamente.',
            'Não responda perguntas sobre status imigratório.',
          ],
        },
      },
      home: {
        back: '← Voltar',
        title: '🏠 Se o ICE for à sua casa',
        what: 'O que fazer imediatamente',
        rights: 'Seus direitos legais',
        say: 'O que dizer (roteiro)',
        not: 'O que NÃO fazer',
        intro:
          'Siga estas etapas para proteger sua casa e lidar legalmente com um encontro em casa.',
        sections: {
          what: [
            'Não abra a porta.',
            'Peça que deslizem o mandado por baixo da porta.',
            'Verifique se ele está assinado por um juiz, e não por um agente do ICE.',
            'Verifique se contém o nome e o endereço corretos.',
          ],
          rights: [
            'Os agentes não podem entrar sem um mandado judicial ou seu consentimento.',
            'Você tem o direito de permanecer em silêncio.',
            'Você tem o direito a um advogado.',
          ],
          say: ['"Não autorizo a entrada. Por favor, saiam da propriedade."'],
          not: [
            'Não abra a porta voluntariamente.',
            'Não assine nada.',
            'Não permita a entrada de agentes sem um mandado judicial válido.',
          ],
        },
      },
      work: {
        back: '← Voltar',
        title: '🏢 Se o ICE for ao seu local de trabalho',
        what: 'O que fazer imediatamente',
        rights: 'Seus direitos legais',
        say: 'O que dizer (roteiro)',
        not: 'O que NÃO fazer',
        intro:
          'Use esta orientação para responder com calma, proteger seus direitos e evitar erros prejudiciais no trabalho.',
        sections: {
          what: [
            'Não corra.',
            'Mantenha a calma.',
            'Pergunte se você está livre para sair.',
            'Se a resposta for sim, saia com calma.',
          ],
          rights: [
            'O ICE precisa de um mandado para áreas não públicas.',
            'Você tem o direito de permanecer em silêncio.',
            'Você não precisa responder perguntas sobre status imigratório.',
          ],
          say: ['"Escolho permanecer em silêncio e quero um advogado."'],
          not: [
            'Não forneça informações falsas.',
            'Não entre em pânico nem corra.',
            'Não assine documentos.',
          ],
        },
      },
    },
    legal: {
      privacy: 'Política de privacidade',
      terms: 'Termos de uso',
      deleteAccount: 'Excluir conta',
      consent:
        'Concordo que minhas informações de contato possam ser usadas para comunicação com o escritório de advocacia. Entendo que detalhes jurídicos confidenciais não são armazenados nem compartilhados fora do meu advogado.',
      privacyPolicy: 'Política de privacidade',
      termsOfUse: 'Termos de uso',
      disclaimer:
        'Esta ferramenta fornece apenas informações gerais e não constitui aconselhamento jurídico nem cria uma relação advogado-cliente.',
      attorneyAdvertising:
        'Publicidade de advocacia. Resultados anteriores nao garantem resultados semelhantes.',
      noTracking:
        'Sem rastreamento de terceiros. Seus dados sao usados apenas para comunicacao e servicos juridicos.',
      firmName: 'Cohen, Tucker & Ades, P.C.',
      phone: '📞 +1 (212) 840-0050',
      email: '📧 info@cohentuckerlaw.com',
      address: '📍 42 Broadway, Suite 310, New York, NY',
    },
    privacy: {
      title: 'Política de privacidade',
      intro:
        'Esta Política de Privacidade explica as informações básicas coletadas por meio deste aplicativo e como elas são usadas para apoiar a comunicação e a prestação de serviços.',
      items: [
        'Coletamos informações básicas de contato, incluindo nome, e-mail e telefone.',
        'Os dados são usados apenas para comunicação e prestação de serviços.',
        'Nenhuma venda ou compartilhamento de dados pessoais ocorre por meio deste aplicativo.',
        'As informações jurídicas permanecem confidenciais com o advogado.',
        'Os usuários podem solicitar a exclusão de seus dados.',
      ],
      returnHome: 'Voltar para a página inicial',
    },
    terms: {
      title: 'Termos de uso',
      intro:
        'Estes Termos de Uso descrevem os limites deste aplicativo e as responsabilidades do usuário ao enviar informações.',
      items: [
        'Este aplicativo fornece informações jurídicas gerais, não aconselhamento jurídico.',
        'O uso deste aplicativo não cria uma relação advogado-cliente.',
        'A comunicação com o escritório é necessária para obter representação jurídica.',
        'Os usuários são responsáveis pela precisão das informações enviadas.',
      ],
      returnHome: 'Voltar para a página inicial',
    },
  },
  ht: {
    buttons: {
      getHelp: 'Jwenn èd legal kounye a',
      callNow: 'Rele kounye a',
    },
    system: {
      loadingSecureAccess: 'Ap chaje aksè an sekirite...',
      errorTitle: 'Gen yon pwoblem ki rive',
      errorBody: 'Aplikasyon an rankontre yon erè. Tanpri rafrechi paj la pou eseye ankò.',
      refreshPage: 'Rafrechi paj la',
    },
    name: 'Non konplè',
    name_placeholder: 'Antre non konplè ou',
    header: {
      languageOptions: {
        en: 'Angle',
        es: 'Panyòl',
        ht: 'Kreyòl',
        pt: 'Pòtigè',
        zh: 'Chinwa',
      },
      callNow: 'Rele kounye a',
    },
    floatingContact: {
      title: 'Jwenn èd legal kounye a',
      button: 'Jwenn èd legal kounye a',
    },
    homepage: {
      heroTitle: 'Konnen dwa ou. Rete pwoteje.',
      heroSubtitle:
        'Si ou menm oswa yon moun pa w ka rankontre ajan imigrasyon, zouti sa a ba ou gidans imedya ak aksè dirèk ak yon avoka.',
      primaryButton: 'Pwoteje tèt ou kounye a - aksè GRATIS',
      emergencyButton: 'Ijans - Rele yon avoka',
      howItWorksTitle: 'Kijan sa mache',
      cards: {
        understandRights: {
          title: 'Konnen dwa ou',
          body: 'Jwenn pwoteksyon legal ak gidans ki fèt pou sitiyasyon ki gen anpil presyon.',
        },
        immediateGuidance: {
          title: 'Jwenn gidans imedya',
          body: 'Avanse byen vit depi nan enskripsyon pou rive nan zouti ki ede ou reponn san danje.',
        },
        contactAttorney: {
          title: 'Kontakte yon avoka',
          body: 'Asire aksè ou anvan, epi sèvi ak aplikasyon an pou konekte ak sipò legal.',
        },
      },
      trustTitle: 'Pwoteksyon ou se priyorite nou',
      trustText:
        'Zouti sa a soti nan Cohen, Tucker & Ades, P.C., yon kabinè avoka imigrasyon ki gen eksperyans nan ka ijan ak ka konplike. Zouti sa a bay enfòmasyon sèlman epi li pa kreye relasyon avoka-kliyan.',
      learnMoreTitle: 'Aprann plis sou dwa ou',
      learnMoreBody:
        'Eksplore resous legal, mizajou ak enfòmasyon pratik ki soti nan kabinè a.',
      learnMoreButton: 'Vizite resous legal nou yo',
    },
    home: {
      heroTitle: 'Konnen dwa ou. Rete pwoteje.',
      heroSub:
        'Si ou menm oswa yon moun pa w ka rankontre ajan imigrasyon, zouti sa a ba ou gidans imedya ak aksè dirèk ak yon avoka.',
      howTitle: 'Kijan sa mache',
      card1Title: 'Konnen dwa ou',
      card1Desc: 'Jwenn pwoteksyon legal ak gidans ki fèt pou sitiyasyon ki gen anpil presyon.',
      card2Title: 'Jwenn gidans imedya',
      card2Desc: 'Avanse byen vit depi nan enskripsyon pou rive nan zouti ki ede ou reponn san danje.',
      card3Title: 'Kontakte yon avoka',
      card3Desc: 'Asire aksè ou anvan, epi sèvi ak aplikasyon an pou konekte ak sipò legal.',
      infoTitle: 'Aprann plis sou dwa ou',
      infoDesc: 'Eksplore resous legal, mizajou ak enfòmasyon pratik ki soti nan kabinè a.',
      learnMore: 'Vizite resous legal nou yo',
    },
    register: {
      back: '← Retounen',
      title: 'Kreye kont ou',
      sub:
        'Enskri pou kreye pwofil ou an sekirite epi jwenn aksè ak zouti pwoteksyon legal ou yo.',
      intro:
        'Enskri pou kreye pwofil ou an sekirite epi jwenn aksè ak zouti pwoteksyon legal ou yo.',
      email: 'Imèl',
      emailLabel: 'Imèl',
      emailPlaceholder: 'imel.ou@egzanp.com',
      password: 'Modpas',
      passwordLabel: 'Modpas',
      passwordPlaceholder: 'Kreye yon modpas',
      confirm: 'Konfime modpas',
      confirmPasswordLabel: 'Konfime modpas',
      confirmPasswordPlaceholder: 'Konfime modpas ou',
      registerBtn: 'Enskri',
      submitIdle: 'Enskri',
      submitLoading: 'Ap kreye kont...',
      google: 'Kontinye ak Google',
      continueWithGoogle: 'Kontinye ak Google',
      existing: 'Ou deja gen yon kont?',
      alreadyHaveAccount: 'Ou deja gen yon kont?',
      errors: {
        passwordMismatch: 'Modpas yo pa menm.',
        unableToCreateAccount: 'Nou pa t kapab kreye kont lan.',
        unableToContinueWithGoogle: 'Nou pa t kapab kontinye ak Google.',
      },
    },
    login: {
      back: '← Retounen',
      title: 'Koneksyon kliyan',
      intro:
        'Konekte pou kontinye konfigirasyon pwofil ou an sekirite epi jwenn gidans legal.',
      email: 'Imel',
      emailPlaceholder: 'imel.ou@egzanp.com',
      password: 'Modpas',
      passwordPlaceholder: 'Antre modpas ou',
      submitIdle: 'Konekte',
      submitLoading: 'Ap konekte...',
      createAccount: 'Kreye kont',
      errors: {
        unableToSignIn: 'Nou pa t kapab konekte ou.',
      },
    },
    intake: {
      back: '← Retounen',
      title: 'Konfigirasyon pwofil an sekirite',
      intro:
        'Bati pwofil ou an sekirite pou Cohen, Tucker & Ades, P.C. ka bay zouti legal ak sipò swivi pi byen.',
      nameRequired: 'Non konplè obligatwa',
      email: 'Imèl',
      emailPlaceholder: 'Antre imèl ou',
      emailRequired: 'Imèl obligatwa',
      phone: 'Nimewo telefòn',
      phoneRequired: 'Nimewo telefòn obligatwa',
      address: 'Adrès',
      preferredLanguage: 'Lang prefere',
      preferredLanguagePlaceholder: 'Chwazi lang ou prefere',
      preferredLanguageRequired: 'Lang prefere obligatwa',
      english: 'Angle',
      spanish: 'Panyòl',
      other: 'Lòt',
      describe: 'Dekri sitiyasyon ou yon ti tan',
      descriptionRequired: 'Yon ti deskripsyon obligatwa',
      consent:
        'Mwen dakò pou yo itilize enfòmasyon kontak mwen pou kominike avè m soti nan kabinè avoka a. Mwen konprann detay legal konfidansyèl yo pa estoke ni pataje deyò avoka mwen.',
      contactConsentText:
        'Mwen dakò ak Kondisyon itilizasyon yo ak Règleman sou vi prive a, epi mwen bay Cohen, Tucker & Ades, P.C. pèmisyon pou kontakte m pa telefon, imel, ak SMS (frè mesaj ak done ka aplike). Konsantman pa obligatwa pou anboche kabinè a.',
      contactConsentBeforeTerms: 'Mwen dakò ak ',
      contactConsentBetweenLinks: ' ak ',
      contactConsentAfterPrivacy:
        ' epi mwen bay Cohen, Tucker & Ades, P.C. pèmisyon pou kontakte m pa telefon, imel, ak SMS (frè mesaj ak done ka aplike). Konsantman pa obligatwa pou anboche kabinè a.',
      contactConsentNote:
        'Nou ranmase epi itilize enfòmasyon ou pou kominikasyon ak evalyasyon dosye. Gade Règleman sou vi prive a pou plis detay.',
      submit: 'Aksede dwa legal ou yo',
      errors: {
        mustAgree: 'Ou dwe dakò anvan ou kontinye.',
        submitError: 'Nou pa t kapab fini konfigirasyon an kounye a. Tanpri eseye ankò.',
      },
      mustAcceptTerms: 'Ou dwe dakò ak Kondisyon yo ak Règleman sou vi prive a.',
    },
    dashboard: {
      back: '← Retounen',
      title: 'Chwazi sitiyasyon ou',
      subtitle:
        'Chwazi sitiyasyon ki pi byen koresponn ak enkyetid ou genyen kounye a pou wè gidans legal ki vize sa.',
      intro:
        'Chwazi sitiyasyon ki pi byen koresponn ak enkyetid ou genyen kounye a pou wè gidans legal ki vize sa.',
      publicTitle: '🚓 Si ICE kanpe ou an piblik',
      publicDesc: 'Gid etap pa etap pou arestasyon nan lari, kestyon ak rankont an piblik.',
      workTitle: '🏢 Si ICE vini nan travay ou',
      workDesc: 'Konnen dwa ou nan travay epi sa pou fè si ajan yo rive kote ou ye a.',
      homeTitle: '🏠 Si ICE vini lakay ou',
      homeDesc: 'Aprann kijan pou reponn nan pòt la epi pwoteje fanmi ou dapre lalwa.',
      scenarios: {
        public: {
          title: '🚓 Si ICE kanpe ou an piblik',
          description:
            'Gid etap pa etap pou arestasyon nan lari, kestyon ak rankont an piblik.',
        },
        workplace: {
          title: '🏢 Si ICE vini nan travay ou',
          description:
            'Konnen dwa ou nan travay epi sa pou fè si ajan yo rive kote ou ye a.',
        },
        home: {
          title: '🏠 Si ICE vini lakay ou',
          description: 'Aprann kijan pou reponn nan pòt la epi pwoteje fanmi ou dapre lalwa.',
        },
      },
      contactTitle: '📞 Kontakte avoka',
      contactDesc: 'Kontakte ekip legal nou an touswit pou resevwa gidans ak asistans.',
      contactAttorneyTitle: '📞 Kontakte avoka',
      contactAttorneyBody: 'Kontakte ekip legal nou an touswit pou resevwa gidans ak asistans.',
      getHelp: 'Rele avoka a kounye a',
      callAttorneyNow: 'Rele avoka a kounye a',
      emailAttorney: 'Voye imèl bay avoka a',
      learnMore: 'Aprann plis →',
      logout: 'Dekonekte',
    },
    contactFlow: {
      title: 'N ap konekte ou ak èd legal',
      statusPreparing: 'N ap prepare demann kontak ou a...',
      statusMissing:
        'Nou pa t kapab chaje detay intake ou yo. Ou ka toujou itilize enfomasyon kontak kabinè a anba a.',
      statusGuest:
        'Demann kontak ou a kòmanse deja. Bouyon imel la ta dwe louvri otomatikman. Apre sa, y ap mande ou kreye yon kont.',
      statusStarted:
        'Demann kontak ou a kòmanse deja. Bouyon imel la ta dwe louvri otomatikman. Si li pa louvri, itilize enfomasyon kontak kabinè a anba a.',
      labels: {
        name: 'Non',
        email: 'Imel',
        phone: 'Telefon',
        address: 'Adrès',
        language: 'Lang',
        scenario: 'Sitiyasyon',
        details: 'Detay',
      },
      defaults: {
        guest: 'Envite',
        notProvided: 'Pa bay',
      },
      actions: {
        returnToDashboard: 'Retounen sou tablo a',
        createAccount: 'Kreye yon kont',
      },
      emailDraft: {
        subject: 'Demann èd legal ki soti nan Know Your Rights App',
        greeting: 'Bonjou,',
        intro: 'Mwen bezwen asistans pou kestyon imigrasyon mwen an.',
        detailsLabel: 'Detay:',
        pleaseContact: 'Tanpri kontakte mwen pi vit ke posib.',
        thanks: 'Mèsi.',
      },
    },
    accordion: {
      shared: {
        whatToDoImmediately: 'Sa pou fè touswit',
        yourLegalRights: 'Dwa legal ou',
        whatToSay: 'Sa pou di (script)',
        whatNotToDo: 'Sa pou PA fè',
      },
      public: {
        back: '← Retounen',
        title: '🚓 Si ICE kanpe ou an piblik',
        intro:
          'Swiv etap sa yo pou pwoteje tèt ou epi konsève dwa legal ou pandan yon rankont an piblik.',
        sections: {
          what: [
            'Rete kalm, pa kouri.',
            'Mande: "Èske mwen lib pou ale?"',
            'Si repons lan se wi, ale dousman.',
            'Si repons lan se non, rete an silans.',
          ],
          rights: [
            'Ou gen dwa rete an silans.',
            'Ou pa oblije reponn ki kote ou fèt.',
            'Ou pa oblije montre dokiman ki revele estati imigrasyon ou.',
            'Ou ka refize fouy, eksepte yon ti fouy limite pou sekirite.',
          ],
          say: ['"M ap egzèse dwa mwen pou rete an silans. Mwen vle pale ak yon avoka."'],
          not: [
            'Pa bay manti.',
            'Pa bay fo dokiman.',
            'Pa reziste fizikman.',
            'Pa reponn kestyon sou estati imigrasyon ou.',
          ],
        },
      },
      home: {
        back: '← Retounen',
        title: '🏠 Si ICE vini lakay ou',
        what: 'Sa pou fè touswit',
        rights: 'Dwa legal ou',
        say: 'Sa pou di (script)',
        not: 'Sa pou PA fè',
        intro:
          'Swiv etap sa yo pou pwoteje kay ou epi jere yon rankont lakay ou dapre lalwa.',
        sections: {
          what: [
            'Pa louvri pòt la.',
            'Mande yo glise manda a anba pòt la.',
            'Tcheke si yon jij siyen li, pa yon ajan ICE.',
            'Tcheke si li gen bon non ak bon adrès la.',
          ],
          rights: [
            'Ajan yo pa ka antre san yon manda jidisyè oswa konsantman ou.',
            'Ou gen dwa rete an silans.',
            'Ou gen dwa gen yon avoka.',
          ],
          say: ['"Mwen pa bay konsantman pou nou antre. Tanpri kite pwopriyete a."'],
          not: [
            'Pa louvri pòt la volontèman.',
            'Pa siyen anyen.',
            'Pa kite ajan yo antre san yon manda jidisyè ki valab.',
          ],
        },
      },
      work: {
        back: '← Retounen',
        title: '🏢 Si ICE vini nan travay ou',
        what: 'Sa pou fè touswit',
        rights: 'Dwa legal ou',
        say: 'Sa pou di (script)',
        not: 'Sa pou PA fè',
        intro:
          'Sèvi ak gid sa a pou reponn ak kalm, pwoteje dwa ou epi evite erè ki ka fè ou mal nan travay.',
        sections: {
          what: [
            'Pa kouri.',
            'Rete kalm.',
            'Mande si ou lib pou kite kote a.',
            'Si repons lan se wi, ale dousman.',
          ],
          rights: [
            'ICE bezwen yon manda pou zòn ki pa piblik.',
            'Ou gen dwa rete an silans.',
            'Ou pa oblije reponn kestyon sou estati imigrasyon ou.',
          ],
          say: ['"Mwen chwazi rete an silans epi mwen vle yon avoka."'],
          not: [
            'Pa bay fo enfòmasyon.',
            'Pa panike oswa kouri.',
            'Pa siyen dokiman.',
          ],
        },
      },
    },
    legal: {
      privacy: 'Règleman sou vi prive',
      terms: 'Kondisyon itilizasyon',
      deleteAccount: 'Efase kont',
      consent:
        'Mwen dakò pou yo itilize enfòmasyon kontak mwen pou kominike avè m soti nan kabinè avoka a. Mwen konprann detay legal konfidansyèl yo pa estoke ni pataje deyò avoka mwen.',
      privacyPolicy: 'Règleman sou vi prive',
      termsOfUse: 'Kondisyon itilizasyon',
      disclaimer:
        'Zouti sa a bay enfòmasyon jeneral sèlman epi li pa konstitye konsèy legal ni li pa kreye yon relasyon avoka-kliyan.',
      attorneyAdvertising:
        'Piblisite avoka. Rezilta anvan yo pa garanti menm kalite rezilta yo.',
      noTracking:
        'Pa gen okenn swivi twazyèm pati. Done ou yo sèvi sèlman pou kominikasyon ak sèvis legal.',
      firmName: 'Cohen, Tucker & Ades, P.C.',
      phone: '📞 +1 (212) 840-0050',
      email: '📧 info@cohentuckerlaw.com',
      address: '📍 42 Broadway, Suite 310, New York, NY',
    },
    privacy: {
      title: 'Règleman sou vi prive',
      intro:
        'Règleman sou Vi Prive sa a eksplike enfòmasyon debaz yo kolekte atravè aplikasyon sa a ak kijan yo itilize yo pou sipòte kominikasyon ak sèvis yo.',
      items: [
        'Nou kolekte enfòmasyon debaz sou kontak, tankou non, imèl ak telefòn.',
        'Done yo itilize sèlman pou kominikasyon ak sèvis yo.',
        'Pa gen okenn vann oswa pataj done pèsonèl ki fèt atravè aplikasyon sa a.',
        'Enfòmasyon legal yo rete konfidansyèl ak avoka a.',
        'Itilizatè yo ka mande pou efase done yo.',
      ],
      returnHome: 'Retounen lakay',
    },
    terms: {
      title: 'Kondisyon itilizasyon',
      intro:
        'Kondisyon Itilizasyon sa yo dekri limit aplikasyon sa a ak responsablite itilizatè a lè li soumèt enfòmasyon.',
      items: [
        'Aplikasyon sa a bay enfòmasyon legal jeneral, pa konsèy legal.',
        'Itilizasyon aplikasyon sa a pa kreye yon relasyon avoka-kliyan.',
        'Kominikasyon ak kabinè a nesesè pou jwenn reprezantasyon legal.',
        'Itilizatè yo responsab pou presizyon enfòmasyon yo soumèt.',
      ],
      returnHome: 'Retounen lakay',
    },
  },
  zh: {
    buttons: {
      getHelp: '立即获取法律帮助',
      callNow: '立即致电',
    },
    system: {
      loadingSecureAccess: '正在加载安全访问...',
      errorTitle: '出现错误',
      errorBody: '应用遇到错误。请刷新页面后重试。',
      refreshPage: '刷新页面',
    },
    name: '姓名',
    name_placeholder: '请输入您的姓名',
    header: {
      languageOptions: {
        en: '英语',
        es: '西班牙语',
        ht: '海地克里奥尔语',
        pt: '葡萄牙语',
        zh: '中文',
      },
      callNow: '立即致电',
    },
    floatingContact: {
      title: '立即获取法律帮助',
      button: '立即获取法律帮助',
    },
    homepage: {
      heroTitle: '了解您的权利。保护自己。',
      heroSubtitle:
        '如果您或您的家人可能会遇到移民执法，这个工具会为您提供即时指导，并直接帮助您联系律师。',
      primaryButton: '立即获得保护 - 免费访问',
      emergencyButton: '紧急情况 - 致电律师',
      howItWorksTitle: '使用方式',
      cards: {
        understandRights: {
          title: '了解您的权利',
          body: '获取为高压情况设计的法律保护和实用指导。',
        },
        immediateGuidance: {
          title: '获取即时指导',
          body: '快速完成注册并进入帮助您安全应对的工具。',
        },
        contactAttorney: {
          title: '联系律师',
          body: '先确保您的访问权限，然后使用应用程序联系法律支持。',
        },
      },
      trustTitle: '您的保护是我们的首要任务',
      trustText:
        '本工具由 Cohen, Tucker & Ades, P.C. 提供，这是一家在紧急和复杂案件方面经验丰富的移民律师事务所。本工具仅供提供信息之用，不会建立律师与客户关系。',
      learnMoreTitle: '进一步了解您的权利',
      learnMoreBody:
        '查看律师事务所提供的法律资源、最新信息和实用内容。',
      learnMoreButton: '访问我们的法律资源',
    },
    home: {
      heroTitle: '了解您的权利。保护自己。',
      heroSub:
        '如果您或您的家人可能会遇到移民执法，这个工具会为您提供即时指导，并直接帮助您联系律师。',
      howTitle: '使用方式',
      card1Title: '了解您的权利',
      card1Desc: '获取为高压情况设计的法律保护和实用指导。',
      card2Title: '获取即时指导',
      card2Desc: '快速完成注册并进入帮助您安全应对的工具。',
      card3Title: '联系律师',
      card3Desc: '先确保您的访问权限，然后使用应用程序联系法律支持。',
      infoTitle: '进一步了解您的权利',
      infoDesc: '查看律师事务所提供的法律资源、最新信息和实用内容。',
      learnMore: '访问我们的法律资源',
    },
    register: {
      back: '← 返回',
      title: '创建您的账户',
      sub:
        '注册以安全创建您的个人资料，并使用您的法律保护工具。',
      intro:
        '注册以安全创建您的个人资料，并使用您的法律保护工具。',
      email: '电子邮箱',
      emailLabel: '电子邮箱',
      emailPlaceholder: 'your.email@example.com',
      password: '密码',
      passwordLabel: '密码',
      passwordPlaceholder: '创建密码',
      confirm: '确认密码',
      confirmPasswordLabel: '确认密码',
      confirmPasswordPlaceholder: '确认您的密码',
      registerBtn: '注册',
      submitIdle: '注册',
      submitLoading: '正在创建账户...',
      google: '使用 Google 继续',
      continueWithGoogle: '使用 Google 继续',
      existing: '已有账户？',
      alreadyHaveAccount: '已有账户？',
      errors: {
        passwordMismatch: '两次输入的密码不一致。',
        unableToCreateAccount: '无法创建账户。',
        unableToContinueWithGoogle: '无法使用 Google 继续。',
      },
    },
    login: {
      back: '← 返回',
      title: '客户登录',
      intro: '登录后可继续完成安全资料设置并获取法律指导。',
      email: '电子邮箱',
      emailPlaceholder: 'your.email@example.com',
      password: '密码',
      passwordPlaceholder: '请输入您的密码',
      submitIdle: '登录',
      submitLoading: '正在登录...',
      createAccount: '创建账户',
      errors: {
        unableToSignIn: '无法登录。',
      },
    },
    intake: {
      back: '← 返回',
      title: '安全资料设置',
      intro:
        '建立您的安全资料，以便 Cohen, Tucker & Ades, P.C. 更有效地为您提供法律工具和后续支持。',
      nameRequired: '必须填写姓名',
      email: '电子邮箱',
      emailPlaceholder: '请输入您的电子邮箱',
      emailRequired: '必须填写电子邮箱',
      phone: '电话号码',
      phoneRequired: '必须填写电话号码',
      address: '地址',
      preferredLanguage: '首选语言',
      preferredLanguagePlaceholder: '请选择您的首选语言',
      preferredLanguageRequired: '必须选择首选语言',
      english: '英语',
      spanish: '西班牙语',
      other: '其他',
      describe: '请简要说明您的情况',
      descriptionRequired: '必须填写简要说明',
      consent:
        '我同意律师事务所使用我的联系信息与我沟通。我理解，机密法律细节不会在我的律师之外被存储或共享。',
      contactConsentText:
        '我同意服务条款和隐私政策，并同意 Cohen, Tucker & Ades, P.C. 通过电话、电子邮件和短信与我联系（可能产生短信和流量费用）。是否同意并不是聘请该律所的前提条件。',
      contactConsentBeforeTerms: '我同意',
      contactConsentBetweenLinks: '和',
      contactConsentAfterPrivacy:
        '，并同意 Cohen, Tucker & Ades, P.C. 通过电话、电子邮件和短信与我联系（可能产生短信和流量费用）。是否同意并不是聘请该律所的前提条件。',
      contactConsentNote:
        '我们收集并使用您的信息用于沟通和案件评估。详情请参阅隐私政策。',
      submit: '查看您的法律权利',
      errors: {
        mustAgree: '继续之前，您必须先同意。',
        submitError: '我们暂时无法完成设置。请再试一次。',
      },
      mustAcceptTerms: '您必须同意服务条款和隐私政策。',
    },
    dashboard: {
      back: '← 返回',
      title: '选择您的情形',
      subtitle:
        '请选择最符合您当前情况的选项，以查看针对性的法律指导。',
      intro:
        '请选择最符合您当前情况的选项，以查看针对性的法律指导。',
      publicTitle: '🚓 如果 ICE 在公共场所拦下您',
      publicDesc: '针对街头拦查、问话和公共场所遭遇的分步指导。',
      workTitle: '🏢 如果 ICE 来到您的工作地点',
      workDesc: '了解您在工作中的权利，以及执法人员接近您工作地点时该怎么做。',
      homeTitle: '🏠 如果 ICE 来到您家',
      homeDesc: '了解如何在门口应对，并依法保护您的家庭。',
      scenarios: {
        public: {
          title: '🚓 如果 ICE 在公共场所拦下您',
          description:
            '针对街头拦查、问话和公共场所遭遇的分步指导。',
        },
        workplace: {
          title: '🏢 如果 ICE 来到您的工作地点',
          description:
            '了解您在工作中的权利，以及执法人员接近您工作地点时该怎么做。',
        },
        home: {
          title: '🏠 如果 ICE 来到您家',
          description: '了解如何在门口应对，并依法保护您的家庭。',
        },
      },
      contactTitle: '📞 联系律师',
      contactDesc: '请立即联系我们的法律团队，获取指导和帮助。',
      contactAttorneyTitle: '📞 联系律师',
      contactAttorneyBody: '请立即联系我们的法律团队，获取指导和帮助。',
      getHelp: '立即致电律师',
      callAttorneyNow: '立即致电律师',
      emailAttorney: '给律师发邮件',
      learnMore: '了解更多 →',
      logout: '退出登录',
    },
    contactFlow: {
      title: '正在为您连接法律帮助',
      statusPreparing: '正在准备您的联系请求...',
      statusMissing:
        '我们无法加载您的登记信息。您仍然可以使用下方律师事务所的联系信息。',
      statusGuest:
        '您的联系请求已开始处理。电子邮件草稿应会自动打开。接下来系统会提示您创建账户。',
      statusStarted:
        '您的联系请求已开始处理。电子邮件草稿应会自动打开。如果没有打开，请使用下方律师事务所的联系信息。',
      labels: {
        name: '姓名',
        email: '电子邮箱',
        phone: '电话',
        address: '地址',
        language: '语言',
        scenario: '情形',
        details: '详情',
      },
      defaults: {
        guest: '访客',
        notProvided: '未提供',
      },
      actions: {
        returnToDashboard: '返回主页面板',
        createAccount: '创建账户',
      },
      emailDraft: {
        subject: '来自 Know Your Rights App 的法律帮助请求',
        greeting: '您好，',
        intro: '我需要移民事务方面的帮助。',
        detailsLabel: '详情：',
        pleaseContact: '请尽快与我联系。',
        thanks: '谢谢。',
      },
    },
    accordion: {
      shared: {
        whatToDoImmediately: '立即该做什么',
        yourLegalRights: '您的法律权利',
        whatToSay: '该说什么（示例）',
        whatNotToDo: '不要做什么',
      },
      public: {
        back: '← 返回',
        title: '🚓 如果 ICE 在公共场所拦下您',
        intro:
          '请按照以下步骤在公共场所遭遇执法时保护自己并维护您的法律权利。',
        sections: {
          what: [
            '保持冷静，不要逃跑。',
            '问：“我可以离开吗？”',
            '如果可以，请冷静离开。',
            '如果不可以，请保持沉默。',
          ],
          rights: [
            '您有权保持沉默。',
            '您不必回答您出生在哪里。',
            '您不必出示暴露移民身份的文件。',
            '您可以拒绝搜查，但出于安全原因的有限拍身检查除外。',
          ],
          say: ['"我正在行使保持沉默的权利。我想和律师谈话。"'],
          not: [
            '不要撒谎。',
            '不要提供假证件。',
            '不要进行肢体反抗。',
            '不要回答有关移民身份的问题。',
          ],
        },
      },
      home: {
        back: '← 返回',
        title: '🏠 如果 ICE 来到您家',
        what: '立即该做什么',
        rights: '您的法律权利',
        say: '该说什么（示例）',
        not: '不要做什么',
        intro:
          '请按照以下步骤保护您的家庭，并依法处理在家中遭遇执法的情况。',
        sections: {
          what: [
            '不要开门。',
            '要求他们把搜查令从门下塞进来。',
            '确认搜查令是否由法官签署，而不是由 ICE 官员签署。',
            '确认上面的姓名和地址是否正确。',
          ],
          rights: [
            '没有司法搜查令或未经您同意，执法人员不得进入。',
            '您有权保持沉默。',
            '您有权请律师。',
          ],
          say: ['"我不同意你们进入。请离开这处房产。"'],
          not: [
            '不要主动开门。',
            '不要签署任何文件。',
            '没有有效的司法搜查令，不要让执法人员进入。',
          ],
        },
      },
      work: {
        back: '← 返回',
        title: '🏢 如果 ICE 来到您的工作地点',
        what: '立即该做什么',
        rights: '您的法律权利',
        say: '该说什么（示例）',
        not: '不要做什么',
        intro:
          '请使用以下指导冷静应对，保护您的权利，并避免在工作中出现有害错误。',
        sections: {
          what: [
            '不要逃跑。',
            '保持冷静。',
            '询问您是否可以离开。',
            '如果可以，请冷静离开。',
          ],
          rights: [
            'ICE 进入非公共区域需要搜查令。',
            '您有权保持沉默。',
            '您不必回答有关移民身份的问题。',
          ],
          say: ['"我选择保持沉默，我需要一位律师。"'],
          not: [
            '不要提供虚假信息。',
            '不要惊慌或逃跑。',
            '不要签署文件。',
          ],
        },
      },
    },
    legal: {
      privacy: '隐私政策',
      terms: '使用条款',
      deleteAccount: '删除账户',
      consent:
        '我同意律师事务所使用我的联系信息与我沟通。我理解，机密法律细节不会在我的律师之外被存储或共享。',
      privacyPolicy: '隐私政策',
      termsOfUse: '使用条款',
      disclaimer:
        '本工具仅提供一般信息，不构成法律建议，也不会建立律师与客户关系。',
      attorneyAdvertising:
        '律师广告。以往结果并不保证未来获得类似结果。',
      noTracking:
        '无第三方跟踪。您的数据仅用于沟通和法律服务。',
      firmName: 'Cohen, Tucker & Ades, P.C.',
      phone: '📞 +1 (212) 840-0050',
      email: '📧 info@cohentuckerlaw.com',
      address: '📍 42 Broadway, Suite 310, New York, NY',
    },
    privacy: {
      title: '隐私政策',
      intro:
        '本隐私政策说明本应用收集的基本信息，以及这些信息如何用于支持沟通和服务提供。',
      items: [
        '我们收集基本联系信息，包括姓名、电子邮箱和电话号码。',
        '数据仅用于沟通和服务提供。',
        '本应用不会出售或共享个人数据。',
        '法律信息将由律师保密。',
        '用户可以要求删除其数据。',
      ],
      returnHome: '返回首页',
    },
    terms: {
      title: '使用条款',
      intro:
        '本使用条款说明本应用的限制，以及提交信息时适用于用户的责任。',
      items: [
        '本应用提供一般法律信息，不提供法律建议。',
        '使用本应用不会建立律师与客户关系。',
        '如需法律代理，必须与律师事务所进行沟通。',
        '用户须对所提交信息的准确性负责。',
      ],
      returnHome: '返回首页',
    },
  },
};
